<template>
  <div class="content">
    <a-form :form="form.fc" class="mt-4" autocomplete="off">
      <a-form-item label="旧密码" v-bind="formItemLayout" v-if="this.step === 1">
        <a-input-password v-decorator="decorators.password_old" placeholder="当前登录密码" />
      </a-form-item>
      <a-form-item label="密码" v-bind="formItemLayout" v-if="this.step === 2" has-feedback>
        <a-input-password v-decorator="decorators.password_new" placeholder="新密码" />
      </a-form-item>
      <a-form-item label="确认密码" v-bind="formItemLayout" v-if="this.step === 2" has-feedback>
        <a-input-password v-decorator="decorators.password_confirm" placeholder="确认密码" />
      </a-form-item>
    </a-form>
    <a-button type="primary" @click="validatorSmsCode" v-if="step === 1">下一步</a-button>
    <a-button @click="goBack" class="mr-2" v-if="step === 2">上一步</a-button>
    <a-button type="primary" v-if="step === 2" @click="handleConfirm" :loading="loading">完成</a-button>
  </div>
</template>
<script>

export default {
  name: 'LoginPassword',
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        password_old: [
          'password_old',
          {
            validateFirst: true,
            rules: [
              { required: true, message: '请输入当前登录密码' },
              { validator: this.$validate('password') },
            ],
          },
        ],
        password_new: [
          'password_new',
          {
            validateFirst: true,
            rules: [
              { required: true, message: '请输入密码' },
              { validator: this.$validate('password') },
            ],
          },
        ],
        password_confirm: [
          'password_confirm',
          {
            validateFirst: true,
            rules: [
              { required: true, message: '请再次确认密码' },
              { validator: this.checkComPassword },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 18,
        },
        labelCol: {
          span: 6,
        },
      },
      step: 1,
      oldPassword: '',
    }
  },
  destroyed () {
    this.manager = null
  },
  created () {
    this.manager = new this.$Manager('auth', 'v1')
  },
  methods: {
    async validatorSmsCode () {
      const { password_old: oldPassword } = await this.form.fc.validateFields()
      this.oldPassword = oldPassword
      this.step = 2
    },
    checkComPassword (rule, value, callback) {
      const password = this.form.fc.getFieldValue('password_new')
      if (password !== value) {
        callback(new Error('两次密码不统一'))
      }
      callback()
    },
    goBack () {
      this.step = 1
    },
    doUpdatePassword (values) {
      return this.manager.performClassAction({
        action: 'password',
        data: values,
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        const params = {
          ...values,
          password_old: this.oldPassword,
        }
        await this.doUpdatePassword(params)
        this.loading = false
        this.$bus.$emit('editPasswordSuccess')
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  width: 350px;
  margin: 0 auto;
  .phone {
    font-size: 18px;
  }
}
</style>
